import {get,post} from 'src/utils/request'

export function getWxAccountList(params){
    return get('/manage/wxAccount/list',params)
}

export function wxAccountSave(data){
    return post('/manage/wxAccount/save',data)
}

export function wxAccountDelete(data){
    return post('/manage/wxAccount/delete',data)
}

export function switchAccount(data){
    return post('/manage/wxAccount/switchAccount',data)
}
